'use strict';

angular.module('atex.dam').controller('EmbedViewController', ['$scope',
  '$q', '$rootScope', '$injector', '$location', '$stateParams', '$modal',
  'ContentService', 'DamTemplateService', 'AuthenticationService',
  'DamNotificationService', 'DamStoryContentService',
  function($scope, $q, $rootScope, $injector, $location, $stateParams, $modal,
           ContentService, DamTemplateService, AuthenticationService,
           DamNotificationService, DamStoryContentService) {

    var ShapeUtils = $injector.get("ShapeUtils");

    $scope.id = $stateParams.id;
    $scope.op = $stateParams.op;

    // the embeded data is a complex object with potentially a lot of unicode characters.
    // simply using encodeURIComponent and decodeURIComponent is insufficient.
    // Moved to use base64 encoding to get over this.
    // However there are various nuances which are described here
    // https://web.dev/articles/base64-encoding
    function decodeEmbedData( embedData ) {
      if ( !embedData ) {
        return {};
      }

      var binString = atob(decodeURIComponent(embedData));
      var uint8Array = new Uint8Array(binString.length);
      for (var i = 0; i < binString.length; i++) {
        uint8Array[i] = binString.charCodeAt(i);
      }

      return JSON.parse(new TextDecoder().decode(uint8Array));
    }

    $scope.linkToPage = function(params) {
      var embedData = params ? decodeEmbedData(params.embedData): {};

      var config = {
        shapeMode: ShapeUtils.LINK_TO_PRINT,
        create: false,
        types: ["article", "text", "image", "photo"],
        profile: true,
        publication:true,
        edition:true,
        zone:true,
        section: false,
        pageNumber: false,
        pagePosition: true,
        pubdate: true
      };

      _.extend(embedData, config);

      var id = "atex.dam.standard.Page.production.dam.create";
      var label = ShapeUtils.getTitle(config.shapeMode);
      var inputTemplate= "p.OnePage";

      $scope.field = _.extend( {}, {
          title: label,
          config: config,
          selectShapeCB: true
        }, embedData );

      return $scope.loadShapeTemplateModal(id, inputTemplate, embedData);
    };

    $scope.loadShapeTemplateModal = function (id, inputTemplate, embedData) {
      var templateScope = $rootScope.$new(true);
      templateScope.type = id;
      templateScope.label = '';
      templateScope.inputTemplate = inputTemplate;

      templateScope.article = atex.Content();

      templateScope.article.local.data = embedData.article.data;
      templateScope.article.local.field = $scope.field;
      templateScope.template = embedData.template;

      templateScope.canBeCancelled = true;

      var modalClass = 'dam-modal-edit confirm-modal ng-cloak';

      if (embedData['select-queue'] && !embedData['link-to-print']) {
        modalClass += ' dam-modal-queue';
      }

      var modal = $modal({
        show : true,
        scope : templateScope,
        template : 'views/dam-link-to-print-modal.html',
        modalClass : modalClass,
        backdrop : 'static',
        keyboard : false
      });

      templateScope.verified = (templateScope.confirm !== true);
      var deferred = $q.defer();

      var destroyModal = function() {
        modal.then(function(modalEl) {
          modalEl.on('hidden.bs.modal', function() {
            templateScope.$destroy();
            angular.element(this).remove();
          });
          modalEl.modal('hide');
        });
      };

      templateScope.doCancel = function() {
        destroyModal();
        deferred.resolve(false);
        $rootScope.$broadcast("dam:cancelItem");
      };

      templateScope.closeModal = function() {
        destroyModal();
        deferred.resolve(false);
      };

      templateScope.doSave = function() {
        destroyModal();
        deferred.resolve(false);
      };

      return deferred.promise;
    };

    $scope.user = undefined;

    AuthenticationService.getCurrentUser().then(function(user) {
      var transferInfo = { id: user.userId, variant: 'onecms' };
      ContentService.getContent(transferInfo).then(function(responseInfo) {
        $scope.user = responseInfo.data;
        DamTemplateService.getTemplateByIdAndInputTemplate($scope.type, $scope.inputTemplate).then(function(template){
          if ( template ) {
            $scope.template = angular.copy(template);


            DamStoryContentService.job($scope.article, $scope.storyContentId).then(function () {
              $scope.article.template = $scope.template;
              $scope.loaded = true;
            });
          }
        });
      });
    });

    $scope.hideSpinner = function() {
      $scope.showSpinner = false;
    };

    $scope.isContentId = function(potentialContentId) {
      return typeof potentialContentId === 'string' && potentialContentId.indexOf('contentid/') === 0;
    };

    $scope.$watch("article.local.queryModel", function () {
      if ( $scope.article && $scope.article.local ) {
        var newErrorString = atex.onecms.ObjectUtils.getByPath($scope.article.local, "queryModel/set/errorString");
        var newError = !_.isEmpty(newErrorString);

        if ( newError !== $scope.inError ) {
          $scope.inError = newError;
        }
      }
    }, true);

    $scope.doSave = function() {
      $scope.showSpinner = true;
      $scope.showSpinner = false;
      $scope.$parent.closeModal();
    };

    var params = $location.search();
    var noHeader = params ? params.noHeader : false;
    $scope.callerId = params ? decodeURIComponent(params.callerId) : '';

    if ( noHeader ) {
      $('#dam-header').css('display', 'none');
    }

    if ( $scope.op ) {
      if ( $scope.op.toLowerCase() === 'link-to-page' ) {
        return $scope.linkToPage(params);
      }
    }
  }]);
